import { Theme } from '@mui/material';

/**
 * The custom property a row sets on the box that holds its cards, to widen them to fill the row.
 * A card reads it and falls back to the theme's card width, so a card on its own is as wide as it
 * always was.
 */
export const IDENTITY_CARD_WIDTH_PROPERTY = '--identity-card-width';

/** The CSS width of an identity card, or of the "new one" card in a row: the row's, else the theme's. */
export function identityCardWidth(theme: Theme): string {
  return `var(${IDENTITY_CARD_WIDTH_PROPERTY}, ${theme.identityCard.width})`;
}
